import React, { useEffect, useState } from 'react'
import "./Products.css"
import Highlights from '../../Component/Highlights/Highlights'
import ProductCard from '../../Component/ProductCard/ProductCard'
import CategoriesData from './CategoriesData'
import { Link, useLocation } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

const Products = (props) => {

    /* global dataLayer */
    const location = useLocation();

    useEffect(() => {
        document.title = props.title;

        const canonicalUrl = `${window.location.origin}${location.pathname}`;
        let canonicalLink = document.querySelector("link[rel='canonical']");
        if (canonicalLink) {
            canonicalLink.setAttribute("href", canonicalUrl);
        } else {
            canonicalLink = document.createElement("link");
            canonicalLink.setAttribute("rel", "canonical");
            canonicalLink.setAttribute("href", canonicalUrl);
            document.head.appendChild(canonicalLink);
        }

        const description = props.descriptions;
        let metaDescription = document.querySelector("meta[name='description']");
        if (metaDescription) {
            metaDescription.setAttribute("content", description);
        } else {
            metaDescription = document.createElement("meta");
            metaDescription.setAttribute("name", "description");
            metaDescription.setAttribute("content", description);
            document.head.appendChild(metaDescription);
        }
    }, [props.title, props.descriptions, location.pathname]);

    const [data, setData] = useState([])
    // console.log(data, "data")

    useEffect(() => {
        const selectedCategory = CategoriesData?.find(category => category.Category === props.heading);
        // console.log(selectedCategory, "selectedCategory")

        if (selectedCategory) {
            setData(selectedCategory.subcategories);
        } else {
            setData([]);
        }
    }, [props.heading]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
    };

    const formatPathname = (pathname) => {
        return pathname.toLowerCase().replace(/\s+/g, '-');
    };

    return (
        <div className='Products'>
            <Highlights />
            <div className='Products-main'>
                <div className='Products-box'>
                    <h3>{props.heading}</h3>
                    {data.map((item) => (
                        <ProductCard item={item} key={item.id} />
                    ))}
                </div>
            </div>
            
        </div>
    )
}

export default Products
